






















































































import { Component, Watch, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";

@Component
export default class FooterNewsletter extends Vue {
  title: string = "";
  checkbox: boolean = false;
  email?: string = "";
  handleRoute = UtilitiesFunctions.handleRoute;
  on: any = {};

  created() {
    // api here
    this.title = "Newsletter";
  }
  resetCheckbox() {
    const email: any = document.getElementById("mce-EMAIL");
    setTimeout(() => {
      if (email) {
        // console.warn(email.getAttribute("value"));
        email.value = "";
        this.checkbox = false;
      }
    }, 1000);
  }
}
